module.exports = __webpack_public_path__ + "files/923cf82fdf23aab877b6171e1f4d53b4.png";